module.exports = __webpack_public_path__ + "assets/map.3321be76.svg";